class Cookie

  parse: (str) =>
    decode = decodeURIComponent
    obj = {}
    pairs = str.split(RegExp(' *; *'))
    pair = undefined
    if '' == pairs[0]
      return obj
    i = 0
    while i < pairs.length
      pair = pairs[i].split('=')
      obj[decode(pair[0])] = decode(pair[1])
      ++i
    obj

  addCookie:(key,value)->
    document.cookie = key+'='+value

window.Cookie = Cookie
